// 导航-->中英文
export const biddingCompensation = {
    'zhCN': {
        // 补偿汇总记录查询
        compensationSummaryList: {
            compensationSummaryName: '名称',
            compensationSummaryNameNull: '名称不可以为空',
            compensationSummaryNameLength: '名称过长',
            startTime: '起始时间',
            startTimeNull: '起始时间不可以为空',
            deadlineNull: '截止时间不可以为空',
            deadline: '截止时间',
            timeLimit: '时间范围',
            compensationType: '补偿类型',
            calculationCompensationType: '计算补偿类型',
            calculationCompensationTypeNull: '计算补偿类型不可以为空',
            status: '状态',
            total: '总数',
            unconfirmed: '未确认',
            confirmed: '已确认',
            terminated: '已停用',
            end: '完结',
            recalculateCompensationPriceSummary: '重新计算补偿单价汇总',
            compensatedType: '已计算补偿类型',
            viewCompensationPriceDetail: '查看补偿单价明细',
            viewProvinceBiddingCompensationPrice: '查看省级标补偿单价',
            addProvinceBiddingCompensationPrice: '新增省级标补偿单价',
            editProvinceBiddingCompensationPrice: '编辑省级标补偿单价',
            viewCityBiddingCompensationPrice: '查看市级标补偿单价',
            addCityBiddingCompensationPrice: '新增市级标补偿单价',
            editCityBiddingCompensationPrice: '编辑市级标补偿单价',
            viewSingleHospitalCompensationPrice: '查看单家医院补偿单价',
            addSingleHospitalCompensationPrice: '新增单家医院补偿单价',
            editSingleHospitalCompensationPrice: '编辑单家医院补偿单价',
            viewSingleTerminalCompensationPrice: '查看单家终端补偿单价',
            addSingleTerminalCompensationPrice: '新增单家终端补偿单价',
            editSingleTerminalCompensationPrice: '编辑单家终端补偿单价',
            viewMilitarySupplyStationCompensationPrice: '查看军供站补偿单价',
            addMilitarySupplyStationCompensationPrice: '新增军供站补偿单价',
            editMilitarySupplyStationCompensationPrice: '编辑军供站补偿单价',
            viewCountyBiddingCompensationPrice: '查看县级标补偿单价',
            addCountyBiddingCompensationPrice: '新增县级标补偿单价',
            editCountyBiddingCompensationPrice: '编辑县级标补偿单价',
            compensationPriceDetail: '补偿单价明细',
            editCompensationPriceSummary: '编辑补偿单价汇总',
            addCompensationPriceSummary: '新增补偿单价汇总',
            isEnd: '是否确认更改状态为已完结？',
            addCompensationSummaryRecord: '新增补偿汇总记录',
            editCompensationSummaryRecord: '编辑补偿汇总记录',
            recalculate: '重新计算',
            recalculateSucceeded: '重新计算成功',
            whetherRecalculate: '是否重新计算？',
            isRecalculate: '所有数据将会被覆盖，是否确认重新计算？',
            province: '省份',
            provinceAndCityNull: '省份/城市不可以为空',
            provinceAndCitySelected: '省份/城市城市未选择',
            provinceAndCityAndCountySelected: '省份/城市/区县区县未选择',
            provinceNull: '省份不可以为空',
            priceEffectiveDate: '价格生效日期',
            priceEffectiveDateNull: '价格生效日期不可以为空',
            priceExpirationDate: '价格失效日期',
            priceExpirationDateNull: '价格失效日期不可以为空',
            actualPrice: '实际采购价',
            actualPriceNull: '实际采购价不可以为空',
            materialGroup: '分型',
            openFare: '开票价',
            openFareNull: '开票价不可以为空',
            coefficientOfCompensation: '补偿系数',
            compensationUnitPrice: '补偿单价',
            confirmationer: '确认人',
            auditTime: '确认时间',
            whetherConfirm: '是否确认？',
            whetherAllConfirm: '当前类型中所有未确认的补偿单价将会被确认，是否确认？',
            confirm: '确认',
            allConfirm: '全部确认',
            city: '城市',
            additionalCompensationFactor: '额外补偿系数',
            changeAdditionalCompensationFactor: '更改额外补偿系数',
            whetherAbnormal: '是否异常',
            whetherDisable: '是否停用',
            principal: '负责人',
            sendFieldConfirmation: '全部发送确认',
            whetherSendFieldConfirmation: '是否发送外勤确认？',
            finalEditor: '修改人',
            finalEditTime: '修改时间',
            remark: '备注',
            abnormal: '异常原因',
            disable: '停用',
            disableSuccess: '停用成功',
            selectCalculationRecord: '请选择要计算的记录',
            openFareLength: '开票价过长',
            actualPriceLength: '实际采购价过长',
            attachment: '附件',
            selectAll: '全选',
            additionalCompensationFactorValidate: '额外补偿系数，最多九位整数，小数点后四位',
            provinceBidding: '省级标',
            cityBidding: '市级标',
            militarySupplyStation: '军供站',
            singleHospital: '单家医院',
            singleTerminal: '单家终端',
            provinceBiddingFormula: '省级标补偿单价计算：开票价-实际采购价*（1-补偿系数）',
            cityBiddingFormula: '市级标补偿单价计算：开票价-实际采购价*（1-补偿系数）',
            militarySupplyStationFormula: '军供站补偿单价计算：开票价-实际采购价*（1-补偿系数）*维护的额外系数',
            singleHospitalFormula: '单家医院补偿单价计算：开票价-实际采购价*（1-补偿系数）',
            singleTerminalFormula: '单家终端补偿单价计算：开票价-实际采购价*（1-补偿系数）',
            coutnyBiddingFormula: '县级标补偿单价计算：开票价-实际采购价*（1-补偿系数）',
            createTime: '开始时间',
            endDate: '结束时间',
            compensationStartTime: '补偿开始时间',
            compensationEndDate: '补偿结束时间',
            whetherWarningData: '存在警告数据,不可以发送确认',
            sendConfirmationSucceeded: '发送确认成功',
            existencePersonInCharge: '没有负责人，是否发送通知？',
            compensationUnitPriceName: '汇总记录名称',
            compensationUnitPriceFormula: '开票价-实际采购价*（1-补偿系数）',
            compensationUnitPriceFormulaExtraCoefficient: '开票价-实际采购价*（1-补偿系数）*维护的额外系数',
            dwCompensationUnitPriceFormula: '实际采购价*D&W补偿系数',
            biddingPriceeValidate: '实际采购价最多九位整数、三位小数',
            agreementPriceValidate: '开票价最多九位整数、二位小数',
            startDateAndEndDateVerification: '起始时间不能大于截止时间',
            startDateAndEndDatePriceVerification: '价格生效日期不能大于价格失效日期',
            nix: '无',
            compensatedTypeConfirm: '已计算补偿类型：',
            selectedCompensationType: '重新计算补偿类型：',
            willBeCoveredForCompensationType: '将被覆盖补偿类型：',
            isWillBeCoveredForCompensationType: '确认后将会覆盖已计算类型(包括外勤确认过的数据)，是否确认？',
            isFieldWillBeCoveredForCompensationType: '是否继续确认？',
            firstDigit: '除小数外，首位数字不可以为0',
            region: '团队',
            totalDifference: '差异总数',
            differenceGenerationTime: '差异生成时间',
            varianceReport: '差异报表',
            differenceType: '差异类型',
            changeDescription: '变更说明',
            alertLanguage: '当前补偿单价汇总项目数据已发生变更，请在自动服务下一次执行后再查看最新的差异对比报表',
            selectBatchDelete: '请选择要删除的记录',
            whetherBatchDetele: '是否批量删除？',
            batchDelete: '批量删除',
            dwCoefficient: 'D&W补偿系数',
            viewDWCompensationPrice: '查看D&W补偿单价',
            addDWCompensationPrice: '新增D&W补偿单价',
            editDWCompensationPrice: '编辑D&W补偿单价',
            dwFormula: 'D&W补偿单价计算：实际采购价*D&W补偿系数',
            effectiveRange: '生效区间',
            taxRate: '税率',
            startMonth: '生效月份',
            endMonth: '失效月份',
            DefaultTicketPriceMaxLen: '最大只能输入4位小数',
            DefaultTicketPriceNoNum: '输入格式错误,请检查.',
            DefaultTicketPrice: '默认开票价',
            DefaultWinningBidPrice: '默认中标价',
            defaultTicketPriceRequird: '默克直发模式下，默认开票价必填',
            defaultBiddingPriceRequird: '委托进口模式下，默认中标价必填',
        },
        // 药店补偿名单维护
        drugStoreSetting: {
            terminalName: '终端名称',
            name: '名称',
            usedName: '曾用名',
            terminalNameNull: '终端名称不可以为空',
            terminalNameLength: '终端名称过长',
            compensationStartTime: '生效日期',
            compensationStartTimeNull: '补偿生效日期不能为空',
            compensationDeadlineNull: '补偿截止日期不能为空',
            compensationDeadline: '截止日期',
            compensationTime: '补偿时间',
            compensationTimeNull: '补偿时间不能为空',
            phCodeNull: 'PHCode不能为空',
            selectTerminal: '选择终端',
            addDrugStoreSettingTitle: '新增药店补偿名单',
            editDrugStoreSettingTitle: '编辑药店补偿名单',
            startDateAndEndDateVerification: '补偿生效日期不能大于等于补偿截止时间',
            compensationCustomerType: '慢病药店类型',
            compensationCustomerTypeVerification: '慢病药店类型不能为空',
        },
        // 补偿计算
        compensationCalculation: {
            quarterCompensationName: '季度补偿计算项目名称',
            startDate: '开始时间',
            endDate: '结束时间',
            recalculate: '重新计算',
            resultView: '查看结果',
            whetherDeleteQuarterCompensation: '是否确定删除季度补偿项目？',
            showEditQuarterCompensation: '编辑季度补偿计算',
            quarterCompensationNameNull: '季度补偿计算项目名称不可以为空',
            quarterCompensationNameLength: '季度补偿计算项目名称超长',
            projectName: '补偿项目名称',
            showAddQuarterCompensation: '新增季度补偿计算',
            selectCompensationUnitPrice: '选择补偿单价',
            notSelectionCompensationUnitPrice: '请选择补偿单价项目',
            distributorName: '经销商名称',
            distributorPHCode: '经销商PHCode',
            principal: '负责人',
            distributorProvince: '经销商省份',
            distributorCity: '经销商城市',
            receiverName: '收货方名称',
            receiverPHCode: '收货方PHcode',
            materialGroup: '分型',
            quantity: '数量',
            unitPrice: '补偿单价',
            amountIncludingTax: '含税补偿金额',
            receiverProvince: '收货方省份',
            receiverCounty: '收货方区县',
            receiverCity: '收货方城市',
            receiverType: '收货方类型',
            batchNumber: '批号',
            shipperName: '货主名称',
            productMaterialGroup: '产品/分型',
            accruedExpenseName: '月度预提项目名称',
            showAddAccruedExpense: '新增月度预提',
            startDateAndEndDateVerification: '起始时间不能大于截止时间',
            nameNull: '名称不可以为空',
            nameLengthTooLong: '名称过长',
            startTimeNull: '开始日期不能为空',
            endTimeNull: '结束日期不能为空',
            totalAmount: '含税补偿金额合计：',
            compensationTotalAmount: '补偿金额合计：',
            reportView: '查看预提报告',
            showEditAccruedExpense: '编辑月度预提',
            whetherDeleteAccruedExpense: '是否确定删除月度预提项目？',
            calculateCompensationPrice: '计算补偿单价',
            reCalculateCompensationPrice: '重新计算补偿单价',
            reCalculateAllCompensationPrice: '重新计算全部补偿单价',
            whetherCalculateCompensationPrice: '是否计算补偿单价？',
            whetherReCalculateCompensationPrice: '是否重新计算补偿单价？',
            calculateCompensationPriceSuccess: '月度预提计算成功。',
            againCalculateCompensationPriceSuccess: '月度预提重新计算成功。',
            salesQuantity: '销量',
            accruedExpenseReportType: '类型',
            whetherRecalculateAccruedExpenses: '是否重新计算月度预提？',
            calculatecAccruedExpensesSuccess: '重新计算月度预提成功。',
            whetherCalculateQuarterlyCompensation: '是否重新计算季度补偿项目？',
            calculateQuarterlyCompensationSuccess: '计算季度补偿项目成功。',
            allCalculateTypeExport: '全部类型单价导出',
            noCompensationUnitPrice: '所选日期无补偿项目',
            showErrorMessage: '错误数据',
            calculateAccruedExpense: '计算预提',
            recalculateCalculateAccruedExpense: '重新计算预提',
            whetherCalculateAccruedExpenses: '是否计算月度预提？',
            calculateAccruedExpenses: '提交预提计算成功',
            resultAccruedExpensesView: '查看预提结果',
            unitPriceHasChangedMessage: '注意：当前补偿单价数据已变更，请在重新计算后再查看最新的补偿结果数据。',
            calculateCompensationUnitPriceSuccess: '补偿单价计算成功。',
            productNameEn: '产品英文名称',
            whetherGenerateAccruedExpensesReport: '是否生成预提报告？',
            generateAccruedExpensesReportSuccess: '生成报告成功',
            generateAccruedExpensesReport: '生成预提报告'
        },
        dwCompensationSetting: {
            addDWSettingTitle: '新增D&W补偿名单',
            editDWSettingTitle: '编辑D&W补偿名单',
            startDateAndEndDateVerification: '补偿生效日期不能大于等于补偿截止时间',
            terminalName: '终端名称',
            name: '名称',
            usedName: '曾用名',
            terminalNameNull: '终端名称不可以为空',
            terminalNameLength: '终端名称过长',
            compensationStartTime: '生效日期',
            compensationStartTimeNull: '补偿生效日期不能为空',
            compensationDeadlineNull: '补偿截止日期不能为空',
            compensationDeadline: '截止日期',
            compensationTime: '补偿时间',
            compensationTimeNull: '补偿时间不能为空',
            phCodeNull: 'PHCode不能为空',
            selectTerminal: '选择终端'
        },
        dwCompensationCoefficientSetting: {
            addDWCompensationCoefficientSettingTitle: '新增D&W补偿系数',
            editDWCompensationCoefficientSettingTitle: '编辑D&W补偿系数',
            dwCompensationCoefficient: 'D&W补偿系数',
            dwCompensationCoefficientNull: '补偿系数最多九位整数、四位小数',
            dwCompensationCoefficientStartTimeNull: 'D&W补偿系数生效日期不能为空',
            dwCompensationCoefficientDeadlineNull: 'D&W补偿系数截止日期不能为空',
            dwCompensationCoefficientDecimalPlaces: 'D&W补偿系数最多九位整数、四位小数',
            dwCompensationCoefficientGreater: 'D&W补偿系数必须为大于0的数字'
        },
        commissiondImport: {
            commissiondImportFormula1:'如填写了补偿单价，则含税补偿单价=补偿单价；',
            commissiondImportFormula2:'如填写了补偿系数，未填写折算分型，则含税补偿单价=机构所在省份产品分型省标价*补偿系数；',
            commissiondImportFormula3:'如填写了补偿系数和折算分型，则含税补偿单价=机构所在省份折算分型省标价*折算系数*补偿系数。',
            maintenanceType:'维护类型',
            maintenanceTypeBeEmpty: '维护类型不能为空',
            whetherRecalculate: '是否重新计算Daily委托进口折让单价？',
            addCommissionedImport: '新增委托进口折让规则成功',
            editCommissionedImport: '编辑委托进口折让规则成功',
            deleteCommissionedImport: '删除委托进口折让规则成功',
            calculateTime: '计算时间',
            operator: '执行人',
            compensationDataType: '计算数据类型',
            calculatedStatus: '计算状态',
            calculatedLog: '计算日志',
            calculateQuarterData: '生成季度数据',
            exportQuarterData: '导出季度数据',
        }
    },
    'enUS': {
        // 补偿汇总记录查询
        compensationSummaryList: {
            compensationSummaryName: 'Name',
            compensationSummaryNameNull: 'Name cannot be empty',
            compensationSummaryNameLength: 'The name is too long',
            startTime: 'Start Time',
            deadline: 'Deadline',
            timeLimit: 'Time limit',
            startTimeNull: 'Start time cannot be empty',
            deadlineNull: 'Deadline cannot be empty',
            compensationType: 'Compensation type',
            calculationCompensationType: 'Calculate the type of compensation',
            calculationCompensationTypeNull: 'Calculated compensation type cannot be empty',
            status: 'Status',
            total: 'Total',
            unconfirmed: 'Unconfirmed',
            confirmed: 'Confirmed',
            terminated: 'Terminated',
            end: 'End',
            recalculateCompensationPriceSummary: 'Recalculate the compensation unit price summary',
            compensatedType: 'Compensated type',
            viewCompensationPriceDetail: 'View compensation unit price details',
            viewProvinceBiddingCompensationPrice: 'View provincial standard compensation unit price',
            addProvinceBiddingCompensationPrice: 'Added provincial standard compensation unit price',
            editProvinceBiddingCompensationPrice: 'Edit provincial standard compensation unit price',
            viewCityBiddingCompensationPrice: 'View city standard compensation unit price',
            addCityBiddingCompensationPrice: 'Added city standard compensation unit price',
            editCityBiddingCompensationPrice: 'Edit city standard compensation unit price',
            viewSingleHospitalCompensationPrice: 'View single hospital compensation unit price',
            addSingleHospitalCompensationPrice: 'Add single hospital compensation unit price',
            editSingleHospitalCompensationPrice: 'Edit single hospital compensation unit price',
            viewSingleTerminalCompensationPrice: 'View single unit terminal compensation unit price',
            addSingleTerminalCompensationPrice: 'Add single unit terminal compensation unit price',
            editSingleTerminalCompensationPrice: 'Edit single unit terminal compensation unit price',
            viewMilitarySupplyStationCompensationPrice: 'View military supply station compensation unit price',
            addMilitarySupplyStationCompensationPrice: 'Add military supply station compensation unit price',
            editMilitarySupplyStationCompensationPrice: 'Edit military supply station compensation unit price',
            viewCountyBiddingCompensationPrice: 'View compensation unit price of county bid',
            addCountyBiddingCompensationPrice: 'Add compensation unit price of county bid',
            editCountyBiddingCompensationPrice: 'Edit compensation unit price of county bid',
            compensationPriceDetail: 'Compensation unit price',
            editCompensationPriceSummary: 'Edit compensation unit price summary',
            addCompensationPriceSummary: 'Add compensation unit price summary',
            isEnd: 'Do you confirm that the change status is Complete?',
            addCompensationSummaryRecord: 'Add compensation summary record',
            editCompensationSummaryRecord: 'Edit compensation summary record',
            recalculate: 'Recalculate',
            recalculateSucceeded: 'Recalculation successful',
            whetherRecalculate: 'Whether to recalculate?',
            isRecalculate: 'All data will be overwritten, is it confirmed that recalculation?',
            province: 'Province',
            provinceAndCityNull: 'Province/city cannot be empty',
            provinceAndCitySelected: 'Province/city city not selected',
            provinceAndCityAndCountySelected: 'Province / city / district / county not selected',
            provinceNull: 'Provinces cannot be empty',
            priceEffectiveDate: 'Price effective date',
            priceEffectiveDateNull: 'Price effective date cannot be empty',
            priceExpirationDateNull: 'Price expiration date cannot be empty',
            materialGroup: 'Material Group',
            actualPrice: 'Actual Price',
            actualPriceNull: 'The actual purchase price cannot be empty',
            openFare: 'Open fare',
            openFareNull: 'Open fare cannot be empty',
            priceExpirationDate: 'Price expiration date',
            coefficientOfCompensation: 'Compensation coefficient',
            compensationUnitPrice: 'Compensation unit price',
            confirmationer: 'Approver',
            auditTime: 'AuditTime',
            whetherConfirm: 'Are you sure you want to confirm it?',
            whetherAllConfirm: 'All compensation unit prices in the current type  result will be confirmed. Are you sure?',
            confirm: 'Confirm',
            allConfirm: 'All Confirm',
            city: 'City',
            additionalCompensationFactor: 'Additional compensation factor',
            changeAdditionalCompensationFactor: 'Change the extra compensation factor',
            whetherAbnormal: 'Is it abnormal',
            whetherDisable: 'Whether to disable',
            principal: 'Principal',
            sendFieldConfirmation: 'Send all confirmation',
            whetherSendFieldConfirmation: 'Whether to send a field confirmation?',
            finalEditor: 'Modifier',
            finalEditTime: 'Change the time',
            remark: 'Remark',
            abnormal: 'Abnormal',
            disable: 'Disable',
            disableSuccess: 'Shutdown successful',
            selectCalculationRecord: 'Please select a record to calculate',
            openFareLength: 'Open fare is too long',
            actualPriceLength: 'Actual purchase price is too long',
            attachment: 'Attachment',
            selectAll: 'Select all',
            additionalCompensationFactorValidate: 'Additional compensation factor up to nine-digit integer, four decimal places',
            provinceBidding: 'Provincial standard',
            cityBidding: 'Municipal standard',
            militarySupplyStation: 'Military station',
            singleHospital: 'Single hospital',
            singleTerminal: 'Single terminal',
            provinceBiddingFormula: 'Provincial standard compensation unit price calculation: open fare - actual purchase price * (1-compensation coefficient)',
            cityBiddingFormula: 'City-level standard compensation unit price calculation: open fare - actual purchase price * (1-compensation coefficient)',
            militarySupplyStationFormula: 'Military unit compensation unit price calculation: open fare - actual purchase price * (1-compensation coefficient) * additional coefficient of maintenance',
            singleHospitalFormula: 'Unit price calculation for single hospital: open fare - actual purchase price * (1-compensation coefficient)',
            singleTerminalFormula: 'Single-unit terminal compensation unit price calculation: open fare - actual purchase price * (1-compensation coefficient)',
            coutnyBiddingFormula: 'Calculation of compensation unit price of county-level bid: ticket price - actual purchase price * (1-compensation coefficient)',
            createTime: 'Create Time',
            endDate: 'End Date',
            compensationStartTime: 'Compensation start time',
            compensationEndDate: 'Compensation end time',
            whetherWarningData: 'There is warning data, cannot send confirmation',
            sendConfirmationSucceeded: 'Send confirmation succeeded',
            existencePersonInCharge: 'No person in charge, do you want to send a notice?',
            compensationUnitPriceName: 'Summary record Name',
            compensationUnitPriceFormula: 'Ticket price - actual purchase price * (1-compensation factor)',
            compensationUnitPriceFormulaExtraCoefficient: 'Open ticket price - actual purchase price * (1-compensation factor) * additional factor for maintenance',
            dwCompensationUnitPriceFormula: 'Actual purchase price * D&W coefficient',
            biddingPriceeValidate: 'The actual purchase price can be up to nine integers and three decimals',
            agreementPriceValidate: 'The maximum fare is nine integers and two decimals',
            startDateAndEndDateVerification: 'Start time cannot be greater than end time',
            startDateAndEndDatePriceVerification: 'Price effective date cannot be greater than price expiration date',
            nix: 'Nix',
            isFieldWillBeCoveredForCompensationType: 'Continue to confirm?',
            isWillBeCoveredForCompensationType: 'After confirmation, the calculated type (including the data confirmed by the field service) will be overwritten. Are you sure?',
            willBeCoveredForCompensationType: 'Will be covered for compensation type',
            selectedCompensationType: 'Recalculate compensation type:',
            compensatedTypeConfirm: 'Compensated type',
            firstDigit: 'The first digit cannot be 0 except decimal',
            region: 'Team',
            totalDifference: 'Total difference',
            differenceGenerationTime: 'Difference generation time',
            varianceReport: 'Variance report',
            differenceType: 'Difference type',
            changeDescription: 'Change Description',
            alertLanguage: 'The current compensation unit price summary item data has changed. Please check the latest difference comparison report after the automatic service is executed next time',
            selectBatchDelete: 'Please select the record to delete',
            whetherBatchDetele: 'Delete in batch？',
            batchDelete: 'Batch Delete',
            dwCoefficient: 'D&W Coefficient',
            viewDWCompensationPrice: 'View D&W compensation unit price',
            addDWCompensationPrice: 'Add D&W compensation unit price',
            editDWCompensationPrice: 'Edit D&W compensation unit price',
            dwFormula: 'D&W compensation unit price calculation: actual purchase price * D&W coefficient',
            effectiveRange: 'Effective Range',
            taxRate: 'Tax Rate',
            startMonth: 'Start Month',
            endMonth: 'End Month',
            DefaultTicketPriceMaxLen:'Can only input up to 4 decimal places',
            DefaultTicketPriceNoNum: 'Input format error, please check',
            DefaultTicketPrice: 'Default Ticket Price',
            DefaultWinningBidPrice: 'Default Winning Bid Price',
            defaultTicketPriceRequird: 'Requird',
            defaultBiddingPriceRequird: 'Requird',
        },
        // 药店补偿名单维护
        drugStoreSetting: {
            terminalName: 'Terminal name',
            name: 'Name',
            usedName: 'Used name',
            compensationStartTime: 'Entry-into-force time',
            compensationStartTimeNull: 'Compensation effective time cannot be empty',
            compensationDeadlineNull: 'Compensation deadline cannot be empty',
            compensationDeadline: 'Compensation deadline',
            compensationTime: 'Compensation time',
            terminalNameNull: 'Terminal name cannot be empty',
            terminalNameLength: 'Terminal name is too long',
            compensationTimeNull: 'Compensation time cannot be empty',
            phCodeNull: 'PHCode cannot be empty',
            selectTerminal: 'Select terminal',
            addDrugStoreSettingTitle: 'New pharmacy compensation list',
            editDrugStoreSettingTitle: 'Edit pharmacy compensation list',
            startDateAndEndDateVerification: 'Compensation effective date cannot be later than or equal to compensation deadline'
        },
        // 补偿计算
        compensationCalculation: {
            quarterCompensationName: 'Quarter Compensation Name',
            startDate: 'Start Date',
            endDate: 'End Date',
            recalculate: 'Recalculate',
            resultView: 'Result View',
            whetherDeleteQuarterCompensation: 'Are you sure to delete quarterly compensation items?',
            showEditQuarterCompensation: 'Edit Quarter Compensation',
            quarterCompensationNameNull: 'Name cannot be empty',
            quarterCompensationNameLength: 'The name is too long',
            projectName: 'Project Name',
            showAddQuarterCompensation: 'Add Quarter Compensation',
            selectCompensationUnitPrice: 'Select Compensation UnitPrice',
            notSelectionCompensationUnitPrice: 'Please select compensation unit price ',
            distributorName: 'Distributor Name',
            distributorPHCode: 'Distributor PHCode',
            principal: 'Rrincipal',
            distributorProvince: 'Distributor Province',
            distributorCity: 'Distributor City',
            receiverName: 'Receiver Name',
            receiverPHCode: 'Receiver PHcode',
            materialGroup: 'MaterialGroup',
            quantity: 'Quantity',
            unitPrice: 'UnitPrice',
            amountIncludingTax: 'Amount Including Tax',
            receiverProvince: 'Receiver Province',
            receiverCounty: 'Receiver County',
            receiverCity: 'Receiver city',
            receiverType: 'Receiver Type',
            batchNumber: 'Batch Number',
            shipperName: 'Shipper Name',
            productMaterialGroup: 'Pruduct/MaterialGroup',
            accruedExpenseName: 'Accrued Expense Name',
            whetherDeleteAccruedExpense: 'Are you sure to delete the monthly accrued items?',
            showAddAccruedExpense: 'Add Accrued Expense',
            startDateAndEndDateVerification: 'The start time cannot be greater than the deadline',
            nameNull: 'Name cannot be empty',
            nameLengthTooLong: 'The name is too long',
            startTimeNull: 'Start date cannot be empty',
            endTimeNull: 'End date cannot be empty',
            showEditAccruedExpense: 'Edit Accrued Expense',
            calculateCompensationPrice: 'Calculate CompensationPrice',
            reCalculateCompensationPrice: 'ReCalculate CompensationPrice',
            reCalculateAllCompensationPrice: 'ReCalculate All CompensationPrice',
            whetherCalculateCompensationPrice: 'Confirm calculate compensation price?',
            whetherReCalculateCompensationPrice: 'Confirm recalculate compensation price?',
            calculateCompensationPriceSuccess: 'Calculate compensation price success.',
            againCalculateCompensationPriceSuccess: 'Monthly accruals recalculated successfully.',
            salesQuantity: 'Sales Quantity',
            accruedExpenseReportType: 'Type',
            whetherRecalculateAccruedExpenses: 'Recalculate monthly accruals?',
            calculatecAccruedExpensesSuccess: 'Recalculate monthly accrual successfully.',
            whetherCalculateQuarterlyCompensation: 'Recalculate quarterly compensation items?',
            calculateQuarterlyCompensationSuccess: 'Calculate the quarterly compensation project successfully.',
            allCalculateTypeExport: 'Export All',
            noCompensationUnitPrice: 'There are no compensation items for the selected date',
            showErrorMessage: 'Error Data',
            calculateAccruedExpense: 'Calculate AccruedExpense',
            recalculateCalculateAccruedExpense: 'Recalculate Calculate AccruedExpense',
            whetherCalculateAccruedExpenses: 'Is monthly withholding calculated?',
            calculateAccruedExpenses: 'The withholding calculation has been successfully submitted',
            resultAccruedExpensesView: 'AccruedExpenses Result',
            unitPriceHasChangedMessage: 'Note: the current compensation unit price data has been changed. Please check the latest compensation result data after recalculation.',
            totalAmount: 'TotalAmount:',
            compensationTotalAmount: 'TotalAmount',
            calculateCompensationUnitPriceSuccess: 'The compensation unit price calculate successed',
            productNameEn: 'Product English Name',
            whetherGenerateAccruedExpensesReport: 'Generate accrual report?',
            generateAccruedExpensesReportSuccess: 'Generate report success',
            generateAccruedExpensesReport: 'Generate report'
        },
        dwCompensationSetting: {
            addDWSettingTitle: 'New D&W compensation list',
            editDWSettingTitle: 'Edit D&W compensation list',
            startDateAndEndDateVerification: 'Compensation effective date cannot be later than or equal to compensation deadline',
            terminalName: 'Terminal name',
            name: 'Name',
            usedName: 'Used name',
            compensationStartTime: 'Entry-into-force time',
            compensationStartTimeNull: 'Compensation effective time cannot be empty',
            compensationDeadlineNull: 'Compensation deadline cannot be empty',
            compensationDeadline: 'Compensation deadline',
            compensationTime: 'Compensation time',
            terminalNameNull: 'Terminal name cannot be empty',
            terminalNameLength: 'Terminal name is too long',
            compensationTimeNull: 'Compensation time cannot be empty',
            phCodeNull: 'PHCode cannot be empty',
            selectTerminal: 'Select terminal'
        },
        dwCompensationCoefficientSetting: {
            addDWCompensationCoefficientSettingTitle: 'New D&W compensation coefficient',
            editDWCompensationCoefficientSettingTitle: 'Edit D&W compensation coefficient',
            dwCompensationCoefficient: 'D&W compensation coefficient',
            dwCompensationCoefficientNull: 'The compensation coefficient can be up to nine integers and four decimals',
            dwCompensationCoefficientStartTimeNull: 'D&W Compensation factor effective date cannot be blank',
            dwCompensationCoefficientDeadlineNull: 'D&W Compensation factor deadline cannot be empty',
            dwCompensationCoefficientDecimalPlaces: 'D&W compensation coefficient can be up to nine integers and four decimals',
            dwCompensationCoefficientGreater: 'D&W Compensation factor must be greater than 0'
        },
        commissiondImport: {
            commissiondImportFormula1:'如填写了补偿单价，则含税补偿单价=补偿单价；',
            commissiondImportFormula2:'如填写了补偿系数，未填写折算分型，则含税补偿单价=机构所在省份产品分型省标价*补偿系数；',
            commissiondImportFormula3:'如填写了补偿系数和折算分型，则含税补偿单价=机构所在省份折算分型省标价*折算系数*补偿系数。',
            maintenanceType:'MaintenanceType',
            maintenanceTypeBeEmpty: 'Required',
            whetherRecalculate: 'Confirm recalculate compensation price?',
            addCommissionedImport: 'Success',
            editCommissionedImport: 'Success',
            deleteCommissionedImport: 'Success',
            calculateTime: 'CalculateTime',
            operator: 'Operator',
            compensationDataType: 'DataType',
            calculatedStatus: 'CalculatedStatus',
            calculatedLog: 'Calculated Log',
            calculateQuarterData: 'Calculate Quarter Data',
            exportQuarterData: 'Export Quarter Data',
        }
    }

}
export default biddingCompensation



// WEBPACK FOOTER //
// ./src/locale/modules/biddingCompensation.js